import { render, staticRenderFns } from "./InspectionFormTable.vue?vue&type=template&id=4e0f4915&"
import script from "./InspectionFormTable.vue?vue&type=script&lang=js&"
export * from "./InspectionFormTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports